import { render, staticRenderFns } from "./ParentDailyComment.vue?vue&type=template&id=aa725292&scoped=true"
import script from "./ParentDailyComment.vue?vue&type=script&lang=js"
export * from "./ParentDailyComment.vue?vue&type=script&lang=js"
import style0 from "./ParentDailyComment.vue?vue&type=style&index=0&id=aa725292&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa725292",
  null
  
)

export default component.exports